"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
var Resource;
(function (Resource) {
    // POS app
    // Orders
    Resource["ORDERS"] = "ORDERS";
    Resource["CREATE_NEW_ORDER"] = "CREATE_NEW_ORDER";
    Resource["EDIT_ORDERS"] = "EDIT_ORDERS";
    Resource["VOID_ORDER_ITEMS"] = "VOID_ORDER_ITEMS";
    Resource["VOID_ORDERS"] = "VOID_ORDERS";
    Resource["EDIT_OTHER_USER_ORDERS"] = "EDIT_OTHER_USER_ORDERS";
    Resource["REFUND_ORDER"] = "REFUND_ORDER";
    Resource["VIEW_COMPLETED_ORDERS"] = "VIEW_COMPLETED_ORDERS";
    Resource["TRANSFER_ORDER"] = "TRANSFER_ORDER";
    // Adjustments & Payments
    Resource["PAYMENTS_AND_ADJUSTMENTS"] = "PAYMENTS_AND_ADJUSTMENTS";
    Resource["ALLOW_ADJUSTMENTS"] = "ALLOW_ADJUSTMENTS";
    Resource["FINISH_SALE"] = "FINISH_SALE";
    Resource["ALLOW_MONEY_MOVEMENTS"] = "ALLOW_MONEY_MOVEMENTS";
    Resource["OPEN_CASH_DRAWER"] = "OPEN_CASH_DRAWER";
    // Manager permissions (this is not a role, this is name of permission group)
    Resource["MANAGER_PERMISSIONS"] = "MANAGER_PERMISSIONS";
    Resource["PERFORM_SHIFT_CLOSURE"] = "PERFORM_SHIFT_CLOSURE";
    Resource["VIEW_SHIFT_SUMMARY"] = "VIEW_SHIFT_SUMMARY";
    Resource["PRINT_SHIFT_SUMMARY"] = "PRINT_SHIFT_SUMMARY";
    Resource["SWITCH_PRICING_GROUP"] = "SWITCH_PRICING_GROUP";
    Resource["SWITCH_MENU"] = "SWITCH_MENU";
    Resource["ALLOW_SYSTEM_LOGOUT"] = "ALLOW_SYSTEM_LOGOUT";
    Resource["UPDATE_SETTINGS"] = "UPDATE_SETTINGS";
    // Office
    // Users
    Resource["USERS"] = "USERS";
    Resource["MANAGE_USERS"] = "MANAGE_USERS";
    Resource["MANAGE_PERMISSIONS"] = "MANAGE_PERMISSIONS";
    Resource["MANAGE_ROLES"] = "MANAGE_ROLES";
    // Products
    Resource["PRODUCTS"] = "PRODUCTS";
    Resource["MANAGE_PRODUCTS"] = "MANAGE_PRODUCTS";
    Resource["DELETE_PRODUCTS"] = "DELETE_PRODUCTS";
    // Menus
    Resource["MENUS"] = "MENUS";
    Resource["MANAGE_MENUS"] = "MANAGE_MENUS";
    Resource["PAGES"] = "PAGES";
    // Price lists
    Resource["PRICE_LISTS"] = "PRICE_LISTS";
    // Settings
    Resource["SETTINGS"] = "SETTINGS";
    Resource["STORE_SETTINGS"] = "STORE_SETTINGS";
    Resource["VENUE_SETTINGS"] = "VENUE_SETTINGS";
    Resource["ORGANIZATION_SETTINGS"] = "ORGANIZATION_SETTINGS";
    // Reports
    Resource["REPORTS"] = "REPORTS";
    Resource["REPORT_SALES"] = "REPORT_SALES";
    Resource["REPORT_PAYMENTS"] = "REPORT_PAYMENTS";
    Resource["REPORT_ADJUSTMENTS"] = "REPORT_ADJUSTMENTS";
    Resource["REPORT_SHIFTS_AND_DEVICES"] = "REPORT_SHIFTS_AND_DEVICES";
    // Features
    Resource["FEATURES"] = "FEATURES";
    // Customers
    Resource["CUSTOMERS"] = "CUSTOMERS";
    // Dashboard
    Resource["DASHBOARD"] = "DASHBOARD";
    Resource["ITEM_AVAILABILITY"] = "ITEM_AVAILABILITY";
    Resource["MANAGE_HARDWARE"] = "MANAGE_HARDWARE";
    Resource["VIEW_CLOSURE_DIFFERENCES"] = "VIEW_CLOSURE_DIFFERENCES";
})(Resource = exports.Resource || (exports.Resource = {}));
//# sourceMappingURL=users.js.map